import { fetch } from '../'

export default {
  async get () {
    let response = await fetch(`/wp-json/wpvue/v1/donation/${window.lang ? '?lang=' + window.lang : ''}`)
    let data = await response.json()
    return response.ok ? data : []
  }
}
